<script>
    import passportsStore from "../../stores/passportsStore";
    import {setPassport} from "../../lib/lib";
    import {createEventDispatcher} from 'svelte/internal';

    export let value;
    export let placeholder = '';
    export let disabled = false;

    const dispatch = createEventDispatcher();

    const onChange = () => {
        setPassportNumber();
        dispatch("change", value);
    }

    const onFocusOut = () => {
        dispatch("focusout", value);
    }

    const setPassportNumber = () => {
        if (value) {
            value = setPassport(value);
        }
    }
</script>
<div class="input-group">
    <span class="input-group-text">{$passportsStore.prefix}</span>
    <input type="text" class="form-control" bind:value="{ value }"
           oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
           maxlength="6" on:change={ onChange } on:focusout={ onFocusOut }
           {placeholder} {disabled}>
</div>